import { LobbyPlayer } from "./LobbyPlayer.js";
import type { GamePlayerData } from "../api/game/GamePlayerData.js";
import { LobbyPlayerType } from "./LobbyPlayerType.js";
import type { APIPublicGamePreferences, APIUser } from "../api/api_schema.js";
import type { BotType } from "../game/BotType.js";


export class UnknownLobbyPlayer extends LobbyPlayer {
    constructor(gameData: GamePlayerData | null) {
        super(LobbyPlayerType.UNKNOWN, gameData);
    }

    override getBotTypeOrNull(): BotType | null {
        return null;
    }

    override getUserOrNull(): APIUser | null {
        return null;
    }

    override isAnonymous(): boolean {
        return false;
    }

    override getShortName(): string {
        return "Unknown";
    }

    override withPreferences(_preferences: APIPublicGamePreferences): LobbyPlayer {
        // Unknown players don't have preferences.
        return this;
    }

    override withGameData(gameData: GamePlayerData): LobbyPlayer {
        return new UnknownLobbyPlayer(
            gameData,
        );
    }

    override equals(other: LobbyPlayer): boolean {
        if (!LobbyPlayer._baseEquals(this, other))
            return false;

        return other instanceof UnknownLobbyPlayer;
    }
}
